<template>
  <div id="nav-bar-top">
    <log-in-modal
      v-if="navType === 'visitor'"
      :modal-is-active="logInModalIsActive"
      transition="expand"
      @toggleModal="toggleLogInModal"
    />
    <nav
      class="navbar is-fixed-top has-text-weight-bold is-bold"
      :class="(navType === 'visitor' || isUserOnHomePage) && !isPrimary ? 'is-white is-tall' : 'is-primary'"
    >
      <div class="container is-flex">
        <div class="navbar-brand">
          <a href="https://www.sidesearch.com" class="navbar-item is-marginless">
            <img
              :src="(navType === 'visitor' || isUserOnHomePage) && !isPrimary ?
              'https://images.squarespace-cdn.com/content/v1/6156ae0e51accc195cc3b7f9/c242dd6d-b6e9-4943-86ad-2efa8e34741a/large+logo-42.png?format=1500w'
              : require('../../assets/logo-white.png')"
              alt="SideSearch Logo"
              class="logo"
            />
          </a>
        </div>
        <div v-if="navType === 'visitor'" class="navbar-menu">
          <div class="navbar-end">
            <div class="navbar-item">
              <a class="has-text-dark is-size-7 is-small has-text-weight-bold" href="https://sidesearch.com/blog">
                Blog
              </a>
            </div>
            <div class="navbar-item">
              <a class="has-text-dark is-size-7 is-small has-text-weight-bold" href="https://sidesearch.com/agency">
                Agency
              </a>
            </div>
            <div class="navbar-item">
              <a class="has-text-dark is-size-7 is-small has-text-weight-bold" href="https://sidesearch.com/faq">
                FAQ
              </a>
            </div>
            <div class="navbar-item" @click="$router.push('/log-in');">
              <button class="button is-rounded is-white is-small has-text-weight-bold">
                Log In
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="getUserType === 'company' || getUserType === 'candidate'"
          class="navbar-menu"
        >
          <div class="navbar-end">
            <router-link v-if="isUserAccountActive && !iconsAreHidden && getUserType === 'company'" to="/dashboard">
              <div class="navbar-item is-stacked has-text-centered">
                <span>
                  <i class="fas fa-search fa-lg" />
                  <small class="is-block is-size-7 icon-title">Find Talent</small>
                </span>
              </div>
            </router-link>
            <router-link
              v-else-if="isUserAccountActive && !iconsAreHidden && getUserType === 'candidate' && isCandidateProfileCreated"
              to="/dashboard"
            >
              <div class="navbar-item is-stacked has-text-centered">
                <span>
                  <i class="far fa-file-alt fa-lg" />
                  <small class="is-block is-size-7 icon-title">My Profile</small>
                </span>
              </div>
            </router-link>
            <router-link
              v-if="isUserAccountActive && !iconsAreHidden && ((getUserType === 'candidate' && isCandidateProfileCreated) || getUserType === 'company')"
              to="/chat"
            >
              <div class="navbar-item is-stacked has-dropdown has-text-centered">
                <span>
                  <i
                    v-if="unreadMessageCount > 0 && unreadMessageCount < 10"
                    class="far fa-envelope fa-lg badge is-badge-danger is-badge-small has-text-weight-bold"
                    :data-badge="unreadMessageCount"
                  />
                  <i
                    v-else-if="unreadMessageCount >= 10"
                    class="far fa-envelope fa-lg badge is-badge-danger is-badge-small has-text-weight-bold"
                    data-badge="9+"
                  />
                  <i
                    v-else
                    class="far fa-envelope fa-lg"
                  />
                  <small class="is-block is-size-7 icon-title">Messages</small>
                </span>
              </div>
            </router-link>
            <router-link v-if="!isUserAccountActive" to="/dashboard">
              <div class="navbar-item email-confirmation-button">
                <button class="button is-text has-text-black is-small has-text-weight-bold">
                  Confirm Your Email
                </button>
              </div>
            </router-link>
            <router-link
              v-if="isFinishProfileButtonShowing"
              to="/candidate/create-profile"
            >
              <div class="navbar-item email-confirmation-button">
                <button class="button is-text has-text-black is-small has-text-weight-bold is-paddingless">
                  Finish Profile
                </button>
              </div>
            </router-link>
            <div>
              <div class="navbar-item is-stacked has-text-centered" @click="toggleAccountDropdown">
                <span>
                  <i class="far fa-user-circle fa-lg" />
                  <small class="is-block is-size-7 icon-title">My Account</small>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style="position:relative;">
          <div v-if="isWelcomeTooltipOpen" class="messages-tooltip">
            <div class="messages-tooltip__header">
              <p class="messages-tooltip__header__title">
                Welcome!
              </p>
              <span class="messages-tooltip__header__icon" @click="handleCloseWelcomeTooltip()">
                <i class="fas fa-times-circle" />
              </span>
            </div>
            <span>This is your inbox, where you'll receive messages from potential Companies looking to hire.</span>
          </div>
          <div
            :class="[
              'account-dropdown',
              'has-text-weight-bold',
              !isAccountDropdownActive ? 'is-hidden' : ''
            ]"
          >
            <small
              class="dropdown-list-item has-text-primary is-size-7 is-block"
              @click="$router.push('/frequently-asked-questions');"
            >FAQ</small>
            <small
              class="dropdown-list-item has-text-primary is-size-7 is-block"
              @click="logOut()"
            >Log Out</small>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import LogInModal from '@/components/Login/LogInModal';

export default {
  name: 'NavBarTop',
  components: {
    LogInModal
  },
  props: {
    iconsAreHidden: {
      type: Boolean,
      required: false,
      default: false
    },
    isPrimary: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isAccountDropdownActive: false,
      logInModalIsActive: false,
      unreadMessageCount: null,
      scrollPosition: null
    };
  },
  computed: {
    isScrollTopAboveFifty () {
      return this.scrollPosition > 50;
    },
    isWelcomeTooltipOpen () {
      return this.$store.state.isWelcomeTooltipOpen;
    },
    isFinishProfileButtonShowing () {
      return (
        this.isUserAccountActive
        && !this.isCandidateProfileCreated
        && this.getUserType !== 'company'
        && this.$route.path !== '/candidate/create-profile'
      );
    },
    isUserLoggedIn () {
      return !!this.$store.getters.getAuthToken;
    },
    getUserType () {
      if (!this.isUserLoggedIn) return 'visitor';

      return this.$store.state.user.account.user_type === 'candidate'
        ? 'candidate'
        : 'company';
    },
    isUserAccountActive () {
      return this.isUserLoggedIn && this.$store.state.user.account.isAccountActive;
    },
    isCandidateProfileCreated () {
      return (
        this.isUserLoggedIn
        && this.getUserType === 'candidate'
        && this.$store.state.user.profile.isProfileCompleted
      );
    },
    isUserOnHomePage () {
      return this.$route.path === '/';
    },
    navType () {
      return this.getUserType;
    }
  },
  created () {
    if (this.$store.state.user && this.$store.state.user.account) {
      this.$socket.emit('add_user', this.$store.state.user.account._id);
      this.getTotalUnreadMessages();
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleUpdateScrollPosition);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleUpdateScrollPosition);
  },
  sockets: {
    notification (val) {
      this.getTotalUnreadMessages();
    },
    messages_read_status_updated (val) {
      this.getTotalUnreadMessages();
    }
  },
  methods: {
    getTotalUnreadMessages () {
      this.$store
        .dispatch('getUnreadMessageCount', {
          id_user: this.$store.state.user.account._id,
          type: this.$store.state.user.account.user_type
        })
        .then(response => {
          this.unreadMessageCount = response.data.data
            .map(chat => chat.unread_message_count)
            .reduce((count, current) => count + current, 0);
        })
        .catch(error => console.log(error));
    },
    toggleAccountDropdown () {
      this.isAccountDropdownActive = !this.isAccountDropdownActive;
    },
    handleCloseWelcomeTooltip () {
      this.$store.commit('TOGGLE_WELCOME_TOOLTIP', false);
    },
    toggleLogInModal () {
      this.logInModalIsActive = !this.logInModalIsActive;
    },
    logOut () {
      this.toggleAccountDropdown();
      this.$store.commit('LOG_OUT');
      this.$socket.close();
      this.$router.push('/log-in');
    },
    handleUpdateScrollPosition ($event) {
      this.scrollPosition = window.scrollY;
    }
  }
};
</script>

<style lang="scss" scoped>
#nav-bar-top {
  z-index: 999999;
}

.navbar.is-transparent {
  background-color: transparent;
  color: $primary-invert;
}

.navbar-item {
  cursor: pointer;
}

.is-stacked {
  color: $primary-invert;
  flex-direction: column;
  transition: all 150ms ease;
}

.is-stacked > span > small {
  line-height: 0.75rem;
  margin-top: 0.35rem;
}

.is-stacked > span > i {
  margin-top: 0.425rem;
}

.is-stacked:hover {
  color: $primary;
  background-color: white;
  .badge[data-badge]::after {
    -webkit-box-shadow: 0 0 0 0.1rem $primary-invert;
    box-shadow: 0 0 0 0.1rem $primary-invert;
  }
}

i {
  margin-bottom: 0.25rem;
}

@media screen and (min-width: 1088px) {
  .navbar {
    min-height: 3.75rem;
  }
}

.navbar.is-transparent .navbar-brand > a.navbar-item:hover,
.navbar.is-transparent .navbar-brand > a.navbar-item.is-active,
.navbar.is-transparent .navbar-brand .navbar-link:hover,
.navbar.is-transparent .navbar-brand .navbar-link.is-active {
  background-color: transparent;
}

.navbar-burger {
  color: white;
}

.logo {
  max-height: 48px !important;
  margin-bottom: -0.7rem;

  @media (max-width: 400px) {
    max-height: 30px !important;
  }

  @media (min-width: 768px) {
    margin-left: 0.5rem;
  }
}

.account-dropdown {
  @media screen and (min-width: 0px) and (max-width: 1087px) {
    right: 0.5rem;
  }

  position: absolute;
  top: 60px;
  right: 0;
  padding: 0.5rem;
  top: 70px;
  position: absolute;
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
  background-color: white;
  border-radius: 6px;
  height: auto;
  width: 100px;
  z-index: 1;

  &:before {
    content: ' ';
    position: absolute;
    top: -5px;
    right: 24px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid white;
    z-index: 2;
  }
}

.messages-tooltip {
  @media screen and (min-width: 768px) and (max-width: 1087px) {
    right: 6.3rem;
  }

  @media screen and (min-width: 0px) and (max-width: 767px) {
    right: 5rem;
  }

  @media screen and (min-width: 1088px) {
    right: 5.4rem;
  }

  color: $dark;
  font-weight: normal;
  font-size: 0.8rem;
  padding: 0.5rem;
  top: 70px;
  position: absolute;
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
  background-color: white;
  border-radius: 6px;
  height: auto;
  width: 200px;
  z-index: 1;

  &:before {
    content: ' ';
    position: absolute;
    top: -5px;
    right: 24px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid white;
    z-index: 2;
  }
}

.messages-tooltip__header {
  display: flex;
  align-items: flex-start;
}

.messages-tooltip__header__title {
  flex-grow: 1;
  font-weight: 600;
}

.messages-tooltip__header__icon {
  cursor: pointer;
}

.dropdown-list-item {
  cursor: pointer;
  text-align: left;
}

.logo-text {
  font-weight: 800;
  letter-spacing: 0.0425rem;
  vertical-align: middle;
}

@media screen and (min-width: 0px) {
  .navbar-end {
    margin-left: auto;
  }
  .navbar-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    padding: 0.5rem !important;
  }
  .navbar-menu {
    display: flex;
    box-shadow: none;
    background-color: transparent;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
  .navbar.is-fixed-top .navbar-menu,
  .navbar.is-fixed-top-touch .navbar-menu {
    -webkit-overflow-scrolling: touch;
    max-height: calc(100vh - 3.25rem);
    overflow: auto;
  }
  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end {
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-left: auto;
  }
  .navbar {
    min-height: 3.75rem;
  }
}

@media screen and (max-width: 1087px) {
  .navbar-menu {
    padding: 0;
  }
}

@media screen and (max-width: 767px) {
  .icon-title {
    font-size: 0.6rem !important;
  }

  .helper-text {
    display: none;
  }
}

.helper-text {
  cursor: default;
  padding-right: 0;
}

.badge[data-badge]::after {
  -webkit-box-shadow: 0 0 0 0.1rem $primary;
  box-shadow: 0 0 0 0.1rem $primary;
  font-weight: bold;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Helvetica", "Arial", sans-serif;
}

.is-stacked:hover {
  color: $primary;
  background-color: white;
  .badge[data-badge]::after {
    -webkit-box-shadow: 0 0 0 0.1rem white;
    box-shadow: 0 0 0 0.1rem white;
  }
}

.email-confirmation-button {
  margin-top: 0.4rem;
}

.is-tall {
  height: 6rem;
}
</style>
